import messages from "@intlify/unplugin-vue-i18n/messages";
import { createI18n } from "vue-i18n";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const i18n: any = createI18n({
  locale: "sr",
  fallbackLocale: "sr",
  legacy: false,
  messages,
});

export function changeLanguage(locale: "sr" | "en") {
  //   console.log(locale);
  i18n.global.locale.value = locale;
}

export function $t(key: string): string;
export function $t(key: string, count: number): string;
export function $t(key: string, values: Record<string, string>): string;
export function $t(key: string, values: Record<string, string>, count: number): string;

export function $t(key = "", values?: Record<string, string> | number | string, count?: number): string {
  if (typeof values === "number") {
    return i18n.global.t(key, values);
  }
  if (values && typeof values === "object") {
    if (typeof count === "number") {
      return i18n.global.t(key, values, count);
    }
    return i18n.global.t(key, values);
  }
  return i18n.global.t(key);
}
